export * from './safe-html.pipe';
export * from './safe-html.module';
